import { useCallback } from "react";
import { Grid2 as Grid, Paper, Typography } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import useScreenSize from '../../../../hooks/useScreenSize';
import { statratRed } from "../../../../config/constants";

type ImpressionsChartProps = {
    interactionsByCampaign: { title: string, impressions: number, clicks: number }[];
    size?: number;
}

const ImpressionsChartWidget = ({ interactionsByCampaign, size = 12 }: ImpressionsChartProps) => {
    const screenSize = useScreenSize();

    const getTick = useCallback((value: string) => {
        const limit = interactionsByCampaign.length <= 3 ? 25 : screenSize.width < 1200 ? 6 : 14;
        if (!value) {
            return "";
        } else if (value.length < limit) {
            return value;
        }
        return `${value?.slice(0, limit)}...`;
    }, [interactionsByCampaign, screenSize]);

    return (
        <Grid size={screenSize.width < 1200 ? 12 : size}>
            <Paper elevation={5} sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant="h6">Impressions and Clicks by Campaign</Typography>
                <BarChart
                    dataset={interactionsByCampaign}
                    xAxis={[{
                        scaleType: 'band',
                        dataKey: 'title',
                        valueFormatter: (title, context) => context.location === "tick" ? getTick(title) : title
                    }]}
                    series={[
                      { dataKey: 'impressions', label: 'Impressions', color: statratRed },
                      { dataKey: 'clicks', label: 'Clicks', color: "white" },
                    ]}
                    height={250}
                />
            </Paper>
        </Grid>
    )
}

export default ImpressionsChartWidget;
